import { render, staticRenderFns } from "./PhilosophyView.vue?vue&type=template&id=15c16c00&scoped=true&"
import script from "./PhilosophyView.vue?vue&type=script&lang=js&"
export * from "./PhilosophyView.vue?vue&type=script&lang=js&"
import style0 from "./PhilosophyView.vue?vue&type=style&index=0&id=15c16c00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c16c00",
  null
  
)

export default component.exports